import React from "react";

const LetterNumberOutput: React.FC = () => {
  return <div>LetterNumberOutput content</div>;
};

export default LetterNumberOutput;
